<template>
    <v-row justify="center">
    <v-dialog v-model="dialogGenerate" persistent max-width="1000px">
      <v-card>
        <v-card-title>
            <v-btn icon @click="closeIt()" class="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
          <span class="headline">Générer une nouvelle image</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
                <v-row class="generator">
                    <v-col cols="7">
                        <v-row>
                            <v-col cols="4">
                                <v-text-field label="Largeur" type="number" v-model="dataGeneration.width" dense></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="Longueur" type="number" v-model="dataGeneration.height" dense></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                    <v-checkbox
                                    class='mt-0'
                                    v-model="dataGeneration.crop"
                                    label="Rogner l'image"
                                    ></v-checkbox>
                            </v-col>
                            <v-col class="d-flex" cols="6">
                                <v-select
                                :items="dataGeneration.items"
                                v-model="dataGeneration.format"
                                dense
                                label="Modifier le format"
                                ></v-select>
                            </v-col>
                                <v-col cols="6" class="pr-4">
                                <v-slider
                                    v-if="this.dataGeneration.format == 'jpg'" 
                                    v-model="dataGeneration.qualite"
                                    class="align-center"
                                    max="100"
                                    min="0"
                                    hide-details
                                    dense
                                    label="Qualité"
                                >
                                    <template v-slot:append>
                                    <v-text-field
                                        v-model="dataGeneration.qualite"
                                        class="mt-0 pt-0"
                                        hide-details
                                        single-line
                                        dense
                                        type="number"
                                        style="width: 60px"
                                    ></v-text-field>
                                    </template>
                                </v-slider>
                            </v-col>
                            
                            <v-col cols="4">
                                <v-checkbox
                                    class='mt-0'
                                    v-model="dataGeneration.grey"
                                    dense
                                    label="Passer en niveau de gris"
                                    ></v-checkbox>
                            </v-col>
                            <v-col v-if="this.dataGeneration.grey" cols="8">
                                <v-slider
                                    v-model="dataGeneration.greyValue"
                                    class="align-center"
                                    max="9"
                                    min="-9"
                                    hide-details
                                    dense
                                    label="Luminosité"
                                >
                                    <template v-slot:append>
                                    <v-text-field
                                        v-model="dataGeneration.greyValue"
                                        class="mt-0 pt-0"
                                        hide-details
                                        single-line
                                        dense
                                        type="number"
                                        style="width: 60px"
                                    ></v-text-field>
                                    </template>
                                </v-slider>
                            </v-col>
                            <v-col cols="6" class="pb-0">
                                <v-checkbox
                                    class='mt-0'
                                    v-model="dataGeneration.enableBg"
                                    dense
                                    label="Changer la couleur des marges"
                                    ></v-checkbox>
                            </v-col>
                            <v-col v-if="dataGeneration.enableBg" class="col-6 text-center py-0">
                                <v-color-picker v-model="dataGeneration.bgColor" class="ma-2" canvas-height="50"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="5">
                        <v-row>
                            <p class="col-12">Preview :</p> 
                            <picture class="col-12 text-center background-default">
                                <img :src="dataGeneration.generatedImage" alt="" class="mediaGenerated">
                            </picture>
                            <input type="hidden" :value="dataGeneration.generatedImage" id="urlToCopy">
                            <v-col cols="12" class="d-flex justify-space-around buttons-link">
                                <a :href="dataGeneration.generatedImage+'?force_download'" download class="button btn ">Télécharger</a>
                                <a href="" @click.prevent="copyUrl()">Copier le lien <div :class="showTooltip ? 'active' : ''" class="linkcopied">Lien copié</div></a>
                                
                            </v-col>
                        </v-row> 
                    </v-col>
                </v-row>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
    name: 'GenerateModal',
     data () {
        return {
            generate: false,
            width: "",
            height: "",
            filesize:"",
            showTooltip: false,
            dataGeneration: {
                width:"",
                height:"",
                generatedImage: "./default.jpg",
                qualite: 50, 
                crop: false,
                grey:false,
                greyValue: 0,
                format: "",
                items: ['jpg', 'png', 'gif'],
                enableBg: false,
                bgColor: "#FFFFFF",
            }
        }
    },
    computed: {
        dialogGenerate: {
            get () {
                return this.$store.state.dialogGenerate
            },
            set (value) {
                this.$store.dispatch('setDialogGenerate', value)
            }
        },
        mediaDetails: function(){
            return this.$store.state.mediaDetails
        }
    },
    methods : {
        copyUrl() {
            this.showTooltip = true;
            let url = document.querySelector('#urlToCopy')
            url.setAttribute('type', 'text')   
            url.select()
            document.execCommand('copy');
            url.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges();
            const vm = this;
            setTimeout(function () { vm.showTooltip = false }, 1500)
        },
        closeIt() {
            this.generate = false
            this.dataGeneration.width = "",
            this.dataGeneration.height = "",
            this.dataGeneration.generatedImage = "./default.jpg",
            this.dataGeneration.qualite = 50, 
            this.dataGeneration.crop = false,
            this.dataGeneration.grey = false,
            this.dataGeneration.greyValue = 0,
            this.dataGeneration.format = "",
            this.dataGeneration.items = ['jpg', 'png', 'gif'],
            this.dataGeneration.enableBg = false,
            this.dataGeneration.bgColor = "#FFFFFF",
            this.$store.dispatch('setDialogGenerate', false)
        },
        generateNewFormat(){
            let baseUrl = this.mediaDetails.url
            baseUrl += "?option="
            if(this.dataGeneration.width != "") baseUrl += 'x'+ this.dataGeneration.width + ','
            if(this.dataGeneration.height != "") baseUrl += 'y'+ this.dataGeneration.height + ','
            if(this.dataGeneration.crop) baseUrl += "crop,"
            if(this.dataGeneration.format) baseUrl += "ff"+this.dataGeneration.format + ","
            if(this.dataGeneration.format == 'jpg') baseUrl += "q"+this.dataGeneration.qualite + ","
            if(this.dataGeneration.grey) baseUrl += "gris"+ this.dataGeneration.greyValue+ ","
            if(this.dataGeneration.enableBg) baseUrl += "bg"+this.dataGeneration.bgColor.substring(1)
            this.dataGeneration.generatedImage = baseUrl
        },
    },
    watch : {
        dataGeneration: {
            handler : function(newData){
                if(this.generate){
                    this.generateNewFormat()
                }
                this.generate = true;
            },
            deep:true
        },
    },
  
}
</script>
<style lang="scss">
    .thumb {
        width: auto;
        max-width:500px;
        height:auto;
        max-height:500px;
        border-radius:5px;
    }
    .details {
        h3 {
            margin-bottom:10px;
        }
        p {
            margin-bottom:0;
        }
    }
    .generator {
        padding:20px;
        border-radius:20px;
    }
    .mediaGenerated {
        max-width: 100%;
        height: auto;
        max-height: 300px;
        width: auto;
    }
    .background-default {
        background-image: url("/bg.jpg");
        background-repeat: repeat;
    }
    .close {
        margin-right:10px;
    }
    .buttons-link {
        a {
            position:relative;
        }
        .linkcopied {
            position:absolute;
            opacity:0;
            top:0;
            width:100%;
            text-align: center;
            background-color:#CCC;
            border-radius:10px;
            padding:5px;
            pointer-events:none;
            transition: opacity 0.2s ease-in;
            &.active {
                opacity:1
            }
        }
    }
    
</style>